import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 */
/**
 * Custom con funciones adicionales al formulario de ProduccioncCalidadEspecificaciones
 **/

class CustomProduccionCalidadEspecificaciones extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm                                   = this.initForm.bind(this);
        this.uploadTbEspecificacionesCalidad            = this.uploadTbEspecificacionesCalidad.bind(this);
        this.loadTbEspecificaciones                     = this.loadTbEspecificaciones.bind(this);
        this.gridOptionsEspecificaciones                = Object.assign({}, this.gridOptions);  
        this.valueChangeOpe1                            = this.valueChangeOpe1.bind(this);
        this.valueChangeOpe2                            = this.valueChangeOpe2.bind(this);
        this.eliminarOpe2                               = this.eliminarOpe2.bind(this);
        this.loadTbEspecificacionesDelete               = this.loadTbEspecificacionesDelete.bind(this);
        this.funcionNuevo                               = this.funcionNuevo.bind(this);
        this.modificarOpe1                              = this.modificarOpe1.bind(this);
        this.grabarEspecificacion                       = this.grabarEspecificacion.bind(this);
        this.succesGrabarEspecificacion                 = this.succesGrabarEspecificacion.bind(this);
        this.modificarEspecificacion                    = this.modificarEspecificacion.bind(this);
        this.succesModificarEspecificacion              = this.succesModificarEspecificacion.bind(this);
        this.limpiarCampos                              = this.limpiarCampos.bind(this);

    }

    
    
    initForm() {
        
        console.log("Calidad especificaciones de productos @version 1.01.0018, @author Cristian Ciro");

        this.getField('btnConsultar').setClick(this.uploadTbEspecificacionesCalidad);
        this.getField('btnNuevo').setClick(this.funcionNuevo);
        this.getField('btnGrabarEspecificacion').setVisible(false);
        this.getField('btnModificarEsp').setVisible(false);
        this.getField('btnGrabarEspecificacion').setClick(this.grabarEspecificacion);
        this.getField('btnModificarEsp').setClick(this.modificarEspecificacion);
        this.getField('nombre').setOnChange(this.limpiarCampos);

    }

    limpiarCampos(){
        this.getField('tablaEspecificaciones').toggle(false);
    }

    uploadTbEspecificacionesCalidad(){ // Se consume el servicio que trae un data con las especificaciones de parametros de calidad del articulo. Esto con el boton de consultar
        if(this.getField('codigo').getValue() !== '' && this.getField('codigo').getValue() !== ' ' &&
        this.getField('nombre').getValue() !== '' && this.getField('nombre').getValue() !== ' ' ){ // Se valida que el buscador (codigo y descripcion tengan datos)
            this.getField('codigo').setError(false,"");
            this.getField('nombre').setError(false,"");
            let datos = {
                datos:{
                    value:this.getField('articulo_id').getValue(),
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-calidadespeciprod', operacion: 'articuloid', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.loadTbEspecificaciones,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion ="240-Busca_las_calidades_especificaciones_por_articulo_id";
            this.service.send( 
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.loadTbEspecificaciones, // Se envía a esta función para graficar la data
                error:this.error_,
                general: this.generalFormat
            });*/

        }else{
            // Si no traen datos se le muestra al usuario que es requerido estos dos campos
            if(this.getField('codigo').valid() && this.getField('codigo').getValue() === '' ){
                this.getField('codigo').setError(true,"Este campo es requerido");
            }
            if(this.getField('nombre').valid() && this.getField('nombre').getValue() === '' ){
                this.getField('nombre').setError(true,"Este campo es requerido");
            }
        }
    }
    loadTbEspecificaciones(data){ // Recibe la data del servicio la cual es graficada en esta funcion
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0) // Se valida que data traiga datos para poderla graficar
        {
            let configCellcol = new Map();
            configCellcol.set('operacion1', {cellRenderer:this.valueChangeOpe1, field:'Operación 1'}); //Se crea una columna nueva y se envía a la funcion mencionada
            configCellcol.set('operacion2', {cellRenderer:this.valueChangeOpe2, field:'Operación 2'}); //Se crea una columna nueva y se envía a la funcion mencionada
            this.gridOptionsEspecificaciones['rowData'] = data.model;
            this.getField('tablaEspecificaciones').toggle(true); 
            this.gridOptionsEspecificaciones.paginationPageSize = 100;
            this.getField('tablaEspecificaciones').initData(this.gridOptionsEspecificaciones, configCellcol);
        }    
    }

    valueChangeOpe1(props) { // En la columna que se crea nueva en la tabla se crea un boton el cual es MODIFICAR
        //console.log('entro al value change op1',props.data);
        //let id = props.data.id;
        let  descripcion = props.data.parametro_calidad
        let button = document.createElement("input");
        button.onclick = () => this.modificarOpe1(descripcion);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type","button");
        button.setAttribute("value","Modificar");
        return this.createElementJaivana(button);
    }

    modificarOpe1(descripcion){ // La funcion que realiza el boton es poner visible un boton y esconder el otro  
        //console.log('entro al modificar op1',descripcion);
        this.getField('descripcion').setValue(descripcion);
        this.getField('calidad').setValue(descripcion);
        this.getField('btnModificarEsp').setVisible(true);
        this.getField('btnGrabarEspecificacion').setVisible(false);
    }

    valueChangeOpe2(props){ // en la segunda columna que se crea nueva en la tabla se crea un boton eliminar
        let button = document.createElement("input");
        button.onclick = () => this.eliminarOpe2(props);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type","button");
        button.setAttribute("value","Eliminar");
        return this.createElementJaivana(button);
    }
    eliminarOpe2(props){ // El boton eliminar permite eliminar la calidad especificacion del articulo indicado en la tabla
        let datos = {
            datos:{
                id:props.data.id,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-calidadespeciprod', operacion: 'eliminar', operacion_tipo: 'eliminar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method: 'DELETE',
            body: datos,
            success: this.loadTbEspecificacionesDelete,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = "240-Permite_eliminar_calidad_especificacion";
        this.service.send({
            endpoint:this.constant.formConfiguration(),
            method:'DELETE',
            body:body,
            success:this.loadTbEspecificacionesDelete,
            error:this.error_,
            general: this.generalFormat
        });*/
    }

    loadTbEspecificacionesDelete(response){ // Si se elimina de forma correcta se vuelve a consumir el servicio para recargar la tabla y ya no este lo que se elimino
        if (response.estado_p === 200) {
            this.uploadTbEspecificacionesCalidad();
        }  
    }
    
    funcionNuevo(){ // Al presionar el boton nuevo lo que hace es limpiar los campos mencionados escoder un boton y mostrar otro
        this.getField('valor_inferior').setValue('');
        this.getField('valor_superior').setValue('');
        this.getField('calidad').setValue('');
        this.getField('descripcion').setValue('');
        this.getField('btnGrabarEspecificacion').setVisible(true);
        this.getField('btnModificarEsp').setVisible(false);
    }

    grabarEspecificacion(){ // Al presionar el boton grabar se consume un servicio POST que lo que hace es crear una nueva especificacion 
        if (this.getField('calidad').getValue() !== '' && this.getField('calidad').getValue() !== ' ' && 
        this.getField('descripcion').getValue() !== '' && this.getField('descripcion').getValue() !== ' ' && 
        this.getField('valor_inferior').getValue() !== '' && this.getField('valor_inferior').getValue() !== ' ' &&
        this.getField('valor_superior').getValue() !== '' && this.getField('valor_superior').getValue() !== ' ' &&
        this.getField('codigo').getValue() !== '' && this.getField('codigo').getValue() !== ' ' &&
        this.getField('nombre').getValue() !== '' && this.getField('nombre').getValue() !== ' '){
            this.getField('codigo').setError(false,"");
            this.getField('nombre').setError(false,"");
            this.getField('calidad').setError(false,"");
            this.getField('descripcion').setError(false,"");
            this.getField('valor_inferior').setError(false,"");
            this.getField('valor_superior').setError(false,"");
            if (this.getField('valor_inferior').getValue() <= this.getField('valor_superior').getValue() ){
                let datos = {
                    datos:{
                        articulo_id:this.getField('articulo_id').getValue(),
                        produccion_calidad_parametros_id:this.getField('produccion_calidad_parametros_id').getValue(),
                        valor_inferior:this.getField('valor_inferior').getValue(),
                        valor_superior:this.getField('valor_superior').getValue(),
                    }
                }

                this.generalFormatPmv = { tipo_servicio: 'prod-calidadespeciprod', operacion: 'crear', operacion_tipo: 'crear' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: datos,
                    success: this.succesGrabarEspecificacion,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
                /*this.generalFormat.nombre_accion ="240-Permite_crear_una_calidad_especificacion";
                this.service.send( 
                {
                    endpoint:this.constant.formConfiguration(),
                    method:'POST',
                    body:body,
                    success:this.succesGrabarEspecificacion,
                    error:this.error_,
                    general: this.generalFormat
                });*/
            }else {
                this.getField('fieldAlert').toggle(true,"El valor mínimo no puede ser mayor al máximo","error"); 
            }
        }else{
            this.getField('fieldAlert').toggle(true,"Se debe realizar la busqueda de un parametro de calidad diferente al ya existente","error");
            if(this.getField('codigo').valid() && this.getField('codigo').getValue() === '' ){
                this.getField('codigo').setError(true,"Este campo es requerido");
            }
            if(this.getField('nombre').valid() && this.getField('nombre').getValue() === '' ){
                this.getField('nombre').setError(true,"Este campo es requerido");
            }
                
                
                
                if(this.getField('descripcion').valid() && this.getField('descripcion').getValue() === '' ){
                    this.getField('descripcion').setError(true,"Este campo es requerido");
                }
                if(this.getField('calidad').valid() && this.getField('calidad').getValue() === '' ){
                    this.getField('calidad').setError(true,"Este campo es requerido");
                }
                if(this.getField('valor_superior').valid() && this.getField('valor_superior').getValue() === '' ){
                    this.getField('valor_superior').setError(true,"Este campo es requerido");
                }
                if(this.getField('valor_inferior').valid() && this.getField('valor_inferior').getValue() === '' ){
                    this.getField('valor_inferior').setError(true,"Este campo es requerido");
                }
            }
                
    }

    succesGrabarEspecificacion(response){ // Si se crea una nueva especificacion de forma correcta se muestra un mensaje y se limpian los campos
        if (response.estado_p === 200) {
            this.getField('fieldAlert').toggle(true,"Acción Exitosa","success"); 
            this.getField('valor_inferior').setValue('');
            this.getField('valor_superior').setValue('');
            this.getField('calidad').setValue('');
            this.getField('descripcion').setValue('');
            this.uploadTbEspecificacionesCalidad(); //Se recarga la tabla para poder ver la nueva especificacion
        }  
    }

    modificarEspecificacion(){ //Al presionar el boton modificar consume un servicio PUT lo cual actualiza el parametro o el valor maximo o minimo de la especificacion de el articulo 
        if (this.getField('calidad').getValue() !== '' && this.getField('calidad').getValue() !== ' '){
            if(this.getField('valor_inferior').getValue() !== '' && this.getField('valor_inferior').getValue() !== ' ' &&
            this.getField('valor_superior').getValue() !== '' && this.getField('valor_superior').getValue() !== ' ' ){
            this.getField('valor_inferior').setError(false,"");
            this.getField('valor_superior').setError(false,"");
                if (this.getField('valor_inferior').getValue() <= this.getField('valor_superior').getValue() ){
                    let datos = {
                        datos:{
                            id:parseInt(this.getField('id').getValue()),
                            articulo_id:this.getField('articulo_id').getValue(),
                            produccion_calidad_parametros_id:this.getField('produccion_calidad_parametros_id').getValue(),
                            valor_inferior:this.getField('valor_inferior').getValue(),
                            valor_superior:this.getField('valor_superior').getValue(),
                        }
                    }

                    this.generalFormatPmv = { tipo_servicio: 'prod-calidadespeciprod', operacion: 'modificar', operacion_tipo: 'modificar' };
                    this.service.send({
                        endpoint: this.constant.formConfiguration(),
                        method: 'PUT',
                        body: datos,
                        success: this.succesModificarEspecificacion,
                        error: this.error_,
                        general: this.generalFormatPmv
                    });
                    /*this.generalFormat.nombre_accion ="240-Permite_modificar_una_calidad_especificacion";
                    this.service.send( 
                    {
                        endpoint:this.constant.formConfiguration(),
                        method:'PUT',
                        body:body,
                        success:this.succesModificarEspecificacion,
                        error:this.error_,
                        general: this.generalFormat
                    });*/
                }else{
                    this.getField('fieldAlert').toggle(true,"El valor mínimo no puede ser mayor al máximo","error"); 
                }
            }else{

                if(this.getField('valor_inferior').valid() && this.getField('valor_inferior').getValue() === '' ){
                    this.getField('valor_inferior').setError(true,"Este campo es requerido");
                }
                if(this.getField('valor_superior').valid() && this.getField('valor_superior').getValue() === '' ){
                    this.getField('valor_superior').setError(true,"Este campo es requerido");
                }
            }
        }else{
            this.getField('fieldAlert').toggle(true,"Se debe realizar la busqueda de un parametro de calidad diferente al ya existente","error");
        } 
    }
    
    succesModificarEspecificacion(response){ //Si el servicio responde 200 (exitoso), recarga la tabla y ya debe aparecer el dato actualizado
        if (response.estado_p === 200) {
            this.getField('fieldAlert').toggle(true,"Acción Exitosa","success"); 
            this.getField('calidad').setValue('');
            this.getField('descripcion').setValue('');
            this.uploadTbEspecificacionesCalidad();
        }  
    }
}
FormJaivana.addController("prod-calidadespeciprod",CustomProduccionCalidadEspecificaciones);
export default CustomProduccionCalidadEspecificaciones;